<template>
	<div class="container page">
		<van-nav-bar :title="$t('setting.language')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="items">
			<div class="item van-hairline--bottom" @click="changeLang('kr', $event)">
				<div class="flex_center">
					<img class="flag" src="/img/lang/kr.svg" alt="kr">
					<div class="info">한국어</div>
				</div>
				<div v-if="lang == 'kr'">✓</div>
			</div>
			<div class="item van-hairline--bottom" @click="changeLang('zh', $event)">
				<div class="flex_center">
					<img class="flag" src="/img/lang/zh.svg" alt="zh">
					<div class="info">簡體中文</div>
				</div>
				<div v-if="lang == 'zh'">✓</div>
			</div>
			<div class="item van-hairline--bottom" @click="changeLang('en', $event)">
				<div class="flex_center">
					<img class="flag" src="/img/lang/en.svg" alt="en">
					<div class="info">English</div>
				</div>
				<div v-if="lang == 'en'">✓</div>
			</div>
			<div class="item van-hairline--bottom" @click="changeLang('ja', $event)">
				<div class="flex_center">
					<img class="flag" src="/img/lang/ja.svg" alt="ja">
					<div class="info">日本語では</div>
				</div>
				<div v-if="lang == 'ja'">✓</div>
			</div>
			<div class="item van-hairline--bottom" @click="changeLang('es', $event)">
				<div class="flex_center">
					<img class="flag" src="/img/lang/es.svg" alt="es">
					<div class="info">Español</div>
				</div>
				<div v-if="lang == 'es'">✓</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from "vant";
	export default {
		name: "Language",
		data() {
			return {
				lang: localStorage.getItem("lang") || "kr",
				source: ''
			};
		},
		created() {
			this.replaceLang()
		},
		mounted() {
			this.source = this.$route.params.type
		},
		methods: {
			back() {
				return window.history.back();
			},
			replaceLang() {
				this.$http({
					method: "get",
					url: "replaceLang",
					data: {
						lang: this.lang,
					},
				}).then((res) => {
					console.log(res, 11)
				});
			},
			changeLang(lang) {

				Toast.loading({
					duration: 200,
				});
				
				this.lang = lang;
				this.$i18n.locale = lang;
				// 先写入本地，再请求接口，保证后续请求 header/lang 一致
				localStorage.setItem("lang", lang);
				this.replaceLang();

				if (this.source == 'setting') {
					
					this.$router.push({
						path: '/'
					});
					
				} else {
					
					this.$router.go(-1);
					
				}
			},
		}

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.container.page {
		background: #f2f2f5;
		min-height: 100%;
	}

	.container .items {
		margin: 24px 20px;
		padding: 12px 8px;
		background: transparent;
		font-size: 30px;
		color: #000;
	}

	.container .items .item {
		padding: 28px 24px;
		margin: 0 0 18px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		background: #fff;
		border-radius: 18px;
		box-shadow: 0 10px 28px rgba(79, 43, 138, 0.22), 0 4px 12px rgba(0, 0, 0, 0.12);
		border-bottom-width: 0;
	}

	.container .items .van-hairline--bottom::after {
		border: none !important;
		display: none;
	}

	.container .sign-out {
		margin: 500px 20px 0;
		height: 100px;
		line-height: 100px;
		border-radius: 50px;
		color: #fff;
		font-size: 40px;
		font-weight: bolder;
		border: none;
		background: linear-gradient(270deg, #e6c3a1, #7e5678);
	}

	.container .item .desc {
		font-size: 30px;
		font-weight: 700;
		color: #979799;
	}

	.container .item .right {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.flex_center {
		display: flex;
		align-items: center;
	}

	.flex_center .flag {
		width: 56px;
		height: 56px;
		margin-right: 20px;
		border-radius: 50%;
		object-fit: cover;
		flex-shrink: 0;
		box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
	}
</style>